import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'

export default function SessionMessage({ message }: { message: string | undefined }): React.ReactElement {
  const { t } = useTranslation('generics')

  if (!message) {
    return <Fragment />
  }

  return (
    <div>
      <div className="font-medium">{t('message')}</div>
      <div>{message}</div>
    </div>
  )
}
